<template>
  <div class="page-rechargewithdrawal">
    <Appbar :title="title" />
    <v-card class="ma-3" elevation="0">
      <router-link
        tag="div"
        v-ripple
        class="card-item d-flex justify-space-between align-center px-3"
        to="PayOrWithdrawal?type=recharge">
        <div class="d-flex align-center">
          <i
            class="iconfont qianbao mr-3"
            :class="isDark && 'iconfont-dark'"
            :style="'color:' + $vuetify.theme.themes.light.primary"></i>
          <div class="item-label">充值记录</div>
        </div>
        <i class="iconfont jiantou-right"></i>
      </router-link>
      <router-link
        tag="div"
        v-ripple
        class="card-item d-flex justify-space-between align-center px-3"
        to="PayOrWithdrawal?type=withdrawal">
        <div class="d-flex justify-space-between align-center">
          <i
            class="iconfont tixian mr-3"
            :class="isDark && 'iconfont-dark'"
            :style="'color:' + $vuetify.theme.themes.light.primary"></i>
          <div class="item-content">提现记录</div>
        </div>
        <i class="iconfont jiantou-right"></i>
      </router-link>
      <router-link
        v-if="
          this.gameType.some((ele) => {
            return ele.code == 'realman' || ele.code == 'chess' || ele.code == 'elegame' || ele.code == 'sports'
          })
        "
        tag="div"
        v-ripple
        class="card-item d-flex justify-space-between align-center px-3"
        to="transferRecord">
        <div class="d-flex justify-space-between align-center">
          <i
            class="iconfont Fill mr-3"
            :class="isDark && 'iconfont-dark'"
            :style="'color:' + $vuetify.theme.themes.light.primary"></i>
          <div class="item-content">转账记录</div>
        </div>
        <i class="iconfont jiantou-right"></i>
      </router-link>
    </v-card>
  </div>
</template>

<script>
import Appbar from '@c/layout/Appbar'
import dsfGame from '@c/mixins/dsf.mixins'
export default {
  mixins: [dsfGame],
  components: {
    Appbar
  },
  computed: {
    title() {
      try {
        return this.$store.getters['app/app_my_config'].rechargeWithdrawalRecord.name
      } catch {}
    },
    _config() {
      return this.$store.state.app.appConfig
    },
    isDark() {
      if (this._config.app_config.configValue.isDarkMode) {
        return true
      } else if (this._config.app_config.configValue.template) {
        if (
          this._config.app_config.configValue.template.index &&
          this._config.app_config.configValue.template.index == 'ks'
        ) {
          return true
        } else if (
          this._config.app_config.configValue.template.index &&
          this._config.app_config.configValue.template.index == 'kszl'
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.page-rechargewithdrawal {
  width: 100%;
  height: 100%;
  .card-item {
    height: 50px;
    line-height: normal;
    color: #757575;
    &:nth-child(n + 2) {
      position: relative;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 1px;
        content: '';
        transform: scaleY(0.5);
        background-color: #e6e6e6;
      }
    }
    .iconfont {
      font-size: 25px;
    }
    .iconfont-dark {
      background-image: linear-gradient(-45deg, #c9a25f, #fbdea5);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .jiantou-right {
      font-size: 12px;
      color: #b3b3b3;
    }
  }
}
</style>
